import {Card,CardContent} from '@/components/ui/card';
/** The ramp steps, in rank order. More than seven series fold into "Other" rather than inventing a color. */
export const ramp=Array.from({length:7},(_,i)=>`var(--ramp-${i+1})`);
export const maxSeries=ramp.length;

/** Card shell shared by every dashboard chart: title at left, headline figure at right. */
export function ChartCard({title,figure,subtitle,controls,children}:{title:string;figure?:string;subtitle?:React.ReactNode;controls?:React.ReactNode;children:React.ReactNode}){
 return <Card><CardContent className="grid gap-5">
  <div className="grid gap-2">
   <div className="flex items-start justify-between gap-4"><h2 className="text-lg font-medium tracking-tight">{title}</h2>{figure&&<p className="text-lg font-medium tabular-nums">{figure}</p>}</div>
   {subtitle&&<p className="text-sm text-muted-foreground">{subtitle}</p>}
   {controls}
  </div>
  {children}
 </CardContent></Card>;
}

/** A thin rounded bar on a light track, sized relative to the largest value. */
export function Meter({share,color}:{share:number;color:string}){
 return <span aria-hidden="true" className="block h-1.5 overflow-hidden rounded-full bg-muted"><span className="block h-full rounded-full" style={{width:`${Math.max(2,Math.round(share*100))}%`,backgroundColor:color}}/></span>;
}
